// import $ from 'jquery';
import {OoredooIcon} from "./OoredooIcon";

let $ = window.$ || require('jquery');

import 'jquery-confirm/js/jquery-confirm.js'

export const fixAlertContentHeight = (_alert) => {

    setTimeout(function () {
        let h = parseFloat(_alert.$content.css('height'))
        _alert.$content.css('minHeight', h + 10);

        console.log('fixAlertContentHeight',_alert);
    }, 100)


}
jconfirm.defaults = {
    title: '',
    titleClass: '',
    jqueryConfirmClasses: '',
    type: 'default',
    typeAnimated: true,
    draggable: false,
    dragWindowGap: 15,
    dragWindowBorder: true,
    animateFromElement: false,
    smoothContent: true,
    hideButtons: false,
    hideIcon: false,
    content: 'Are you sure to continue?',
    buttons: {},
    defaultButtons: {
        ok: {
            text: '',
            action: function () {
            }
        },
        close: {
            text: '',
            action: function () {
            }
        },
    },
    contentLoaded: function (data, status, xhr) {
    },
    icon: '',
    iconHtml: '',
    lazyOpen: false,
    bgOpacity: null,
    // theme: 'ooredoo',
    animation: 'scale',
    closeAnimation: 'scale',
    animationSpeed: 400,
    animationBounce: 1,
    rtl: window.application.language.dir === 'rtl',
    container: 'body',
    containerFluid: false,
    backgroundDismiss: false,
    backgroundDismissAnimation: 'shake',
    autoClose: false,
    closeIcon: true,
    // closeIconClass: 'icon-close',
    closeIconClass: 'icon-Icon-112',
    watchInterval: 100,
    columnClass: 'column is-6 col-push-3',
    boxWidth: '50%',
    scrollToPreviousElement: false,
    scrollToPreviousElementAnimate: false,
    useBootstrap: true,
    offsetTop: 40,
    offsetBottom: 40,
    bootstrapClasses: {
        container: 'container',
        containerFluid: 'container-fluid',
        row: 'row',
    },
    onContentReady: function () {
        // fixAlertContentHeight(this);

    },
    onOpenBefore: function () {
        const me = this;

        me.$el.addClass('jconfirm-ooredoo');
        if (me.hideIcon){
            me.$icon.hide();
        }
        if (typeof me.jqueryConfirmClasses === 'string' && me.jqueryConfirmClasses.length){
            me.$el.addClass(me.jqueryConfirmClasses);
        }

        me.$content.children().wrap("<div class='jconfirm-content__inner'></div>");
        if (me.$btnc.find('button').length) {
            me.$btnc.addClass('jconfirm-buttons--' + me.$btnc.find('button').length)
        }
        if (me.hideButtons === true) {
            $.each(me.buttons, function (aName, aBtn) {
                aBtn.hide();
            });

        }

        if (typeof me.onBeforeOpenCallback === 'function'){
            me.onBeforeOpenCallback();
        }

        fixAlertContentHeight(this);
    },
    onOpen: function () {
        const me = this;
        if (me.iconHtml) {
            setTimeout(function () {
                me.setHtmlIcon(me.iconHtml);
            }, 10);
        }
        if (typeof me.onOpenCallback === 'function'){
            me.onOpenCallback();
        }

        // me.$content.css('height',me.$content.height()+10);
    },
    onClose: function () {
    },
    onDestroy: function () {
    },
    onAction: function () {
    },
    onBeforeOpenCallback: function () {
    },
    onOpenCallback: function () {
    },
    setHtmlIcon: function (iconHtml) {
        const me = this;
        if (typeof iconHtml === 'undefined') {
            me.$icon.html('');
            return;
        }
        me.$icon.html(iconHtml);
        me.$titleContainer.show();
    }
};

export const defaultAlert = (message, options = {}) => {

    options.title = '';
    if (typeof message === 'string' && message.length) {
        options.content = message;
    }

    if (typeof options.iconHtml === 'undefined') {
        if (typeof options.icon == 'undefined') {
            options.icon = 'icon-Icon-17';
        }
        options.iconHtml = OoredooIcon(options.icon)
    }

    if (typeof options.buttons === 'undefined') {
        options.buttons = {
            close: {
                text: application.oss.translations.oss_form.close,
                btnClass: 'main-btn',
                action: function () {
                }
            },
        };
    }

    return $.alert(options);

}
export const successAlert = (message, options = {}) => {

    options.title = '';
    if (typeof message === 'string' && message.length) {
        options.content = message;
    }

    if (typeof options.iconHtml === 'undefined') {
        if (typeof options.icon == 'undefined') {
            options.icon = 'icon-Icon-17';
        }
        options.iconHtml = OoredooIcon(options.icon)
    }
    if (typeof options.buttons === 'undefined') {
        options.buttons = {
            close: {
                text: application.oss.translations.oss_form.close,
                btnClass: 'main-btn',
                action: function () {
                }
            },
        };
    }
    return $.alert(options);

}

export const errorAlert = (message, options = {}) => {

    options.title = '';
    options.content = message;
    if (typeof options.iconHtml === 'undefined') {
        if (typeof options.icon == 'undefined') {
            options.icon = 'icon-Icon-17';
        }
        options.iconHtml = OoredooIcon(options.icon)
    }
    if (typeof options.buttons === 'undefined') {
        options.buttons = {
            close: {
                text: application.oss.translations.oss_form.close,
                btnClass: 'main-btn',
                action: function () {
                }
            },
        };
    }
    return $.alert(options);

}